module.exports = __webpack_public_path__ + "img/list-shop.31c1370.svg";